module.exports = __webpack_public_path__ + "static/school_support_img2@2x-2eaf1e21bc19c6f36a7fe420cb4e5de4.jpg";